<template>
	<div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <!-- 按钮 -->
    <list-btn
    :listArr="listArr"
    :sdata="sdata"
    @detail="detail"
    @edit="edit"
    @add="add"
    @del="del"
    @restore="restore"
    isAdd
    isEdit
    isDelStatus
    ></list-btn>

		<!-- 列表 -->
    <tab-list
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="base-factory"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata"
    @dbClick="dbClick">
    </tab-list>

    <!-- 详情 -->
    <el-dialog title="工厂详情"
    :visible.sync="dialogFormVisible"
    customClass="dialog_detail_style"
    v-dialogDrag @closed="closedDialog" >
      <detail :sdata="sdata" class="contnet_box"></detail>
    </el-dialog>

	</div>
</template>

<script>
import {factoryApi} from 'api/base.js'
import listBtn from 'components/btn/listBtn.vue'
import tabList  from 'components/table/list.vue';
import searchBox from './components/list/search.vue';
import detail from './detail.vue';

export default{
	components:{
		listBtn,
		tabList,
    searchBox,
    detail
	},
	data() {
		return {
      dialogFormVisible:false,
			isComponentChild:false,
			isDelList:false,//是否显示已删除的
			sdata:{},
			listArr:[],//列表
			tabColumns:[
         {field: 'companyCode', title: '公司编码',need:true},
        {field: 'companyDesc', title: '公司描述',need:true},
			  {field: 'factoryCode', title: '工厂编码',need:true, width:100,"sortable":true},
			  {field: 'factoryDesc', title: '工厂描述',need:true},
			  {field: 'telephone', title: '联系电话'},
        {field: 'address', title: '地址',
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          /* let address = '';
          if(rowData.proviceDesc) address = rowData.proviceDesc;
          if(rowData.cityDesc) address = address + rowData.cityDesc;
          if(rowData.countyDesc) address = address + rowData.countyDesc;
          if(rowData.streetAdress) address = address +rowData.streetAdress; */
          let address = "";
          if(rowData.area) address = rowData.area;
          if(rowData.streetOrAddress) address = address + rowData.streetOrAddress;
          return address;
        }},
			  {field: 'maintainStatus', title: '状态',
			  formatter: function (rowData,rowIndex,pagingIndex,field) {
			    return rowData.maintainStatus === 'X' ? "已删除" : "正常";
			  }
			  }
			],//表头字段
			maintainStatus:[
        {text:'正常',value:''},
        {text:"已删除",value:"X"},
      ],
      total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:20,//每页显示的数量,
				searchCriteria:{//查询的附加条件

				}
			}
		}
	},
	created(){
		this.getListArr();
	},
	methods:{
    //双击
    dbClick(data){
      this.sdata = data;
      this.detail();
    },
		showErrorMsg(txt){
			this.$message.error(txt);
		},
    //选中数据
    selectSdata(data){
      this.sdata = data;
      console.log(this.sdata)
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getListArr();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getListArr();
    },
		//获取工厂列表
		async getListArr(){
			let res = await this.$post(factoryApi.list,this.fromData);
      console.log(res,'== 工厂列表 ==');
			if(res.status && res.data){
        if(res.data.list){
        	res.data.list.forEach((item,index)=>{
        		if(item.maintainStatus === 'X'){
        			item.isDel = true;
        		}else{
        			item.isDel = false;
        		}
        		item.isChecked = false;
        	});
        }
        this.pages = res.data.pages;
			  this.listArr = res.data.list;
			  this.total = res.data.total;
			}else{
			  this.pages = 0;
			  this.listArr = [];
			  this.total = 0;
			}
		},
    subSearch(){
      this.getListArr()
    },
		handleSelectChange(item,key){
			if(item.isChecked){
				item.isChecked = false;
				this.sdata = {};
			}else{
				this.sdata = item;
				this.sdata.index = key;
				item.isChecked = true;
				this.listArr.forEach((items)=>{
					if(items.factoryId != item.factoryId){
						items.isChecked = false;
					}
				});
				if(item.maintainStatus === 'X'){
					this.sdata.isDel = true;
				}else{
					this.sdata.isDel = false;
				}
			}
		},
		//选择的改变
		changeSelect(val,item,key){
			this.handleSelectChange(item,key);
		},
    //详情
    async detail(){
      if(!this.sdata.factoryId){
      	this.$message.error('请选择要查看的数据');
      	return;
      }
      this.dialogFormVisible = true;
    },
    //关闭弹出层
    closedDialog(){
      this.dialogFormVisible = false;
    },
		//新增
		add(){
			this.$router.push({name: 'base-factory-add'});
		},
		//编辑
		edit(){
			if(!this.sdata.factoryId){
				this.$message.error('请选择要编辑的数据');
				return;
      }
      if(this.sdata.maintainStatus === 'X'){
        this.$message.error('该条记录已删除，不允许编辑！');
				return;
      }
			this.$router.push({name: 'base-factory-edit', params: {id:this.sdata.factoryId}});
		},

    //删除
    del(){
      let vm = this;
      if(!this.sdata.factoryId){
        this.$message.error('请选择需要删除的记录');
        return;
      }
      this.$confirm('确定删除这条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeDataStatus(factoryApi.del,"删除成功！","X");
      }).catch(() => {});
    },
    //恢复删除
    restore(){
      let vm = this;
      if(!this.sdata.factoryId){
        this.$message.error('请选择需要恢复的记录');
        return;
      }
      this.$confirm('恢复此记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          this.changeDataStatus(factoryApi.restore,"修改成功！","");
      });
    },
    /**
     * [ 改变物料状态 ]
     * @param {Object} api 调用的接口
     * @param {Object} message 操作成功后，提示的消息
     * @param {Object} status  操作成功后，状态
     */
    async changeDataStatus(api,message,status){
      this.$store.state.loadingTxt = "处理中...";
      this.$store.state.isLoading = true;
      let res = await this.$get(api,{factoryId:this.sdata.factoryId});
      this.$store.state.isLoading = false;
      if(res.status){
        this.$message.success("工厂"+this.sdata.factoryCode+message);
        this.$set(this.sdata,'maintainStatus',status);
      }else{
        this.$message.error(res.msg);
        this.sdata.isDel = false;
      }
    }
	}
}
</script>

<style>
</style>
